import { useContext } from "react";
import { PRODUCT_TAG_CODES } from "app/constants";
import findLast from "lodash/findLast";
import { shouldShowFavoriteBadge, isBrandWithAccount } from "app/utils/utils";
import { getUnbeatableOffer } from "app/utils/productUtils";
import AppGlobalsContext from "app/AppGlobalsContext";

// Todo replace by icon after migration icons
const GC_DISCONNECTED_ICON = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.33329 4.33366C4.33329 2.30861 5.97491 0.666992 7.99996 0.666992C10.025 0.666992 11.6666 2.30861 11.6666 4.33366V6.00033C11.6666 6.36851 11.3682 6.66699 11 6.66699C10.6318 6.66699 10.3333 6.36851 10.3333 6.00033V4.33366C10.3333 3.04499 9.28863 2.00033 7.99996 2.00033C6.71129 2.00033 5.66663 3.04499 5.66663 4.33366V6.00033C5.66663 6.36851 5.36815 6.66699 4.99996 6.66699C4.63177 6.66699 4.33329 6.36851 4.33329 6.00033V4.33366Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.99996 5.50033C2.98737 5.50033 2.16653 6.32124 2.16663 7.33386L2.16718 13.3339C2.16727 14.3463 2.98806 15.167 4.00051 15.167H11.9998C13.0124 15.167 13.8332 14.3462 13.8332 13.3337V7.33366C13.8332 6.32114 13.0124 5.50033 11.9998 5.50033H3.99996ZM8.66663 9.66699C8.66663 9.29879 8.36816 9.00033 7.99996 9.00033C7.63176 9.00033 7.33329 9.29879 7.33329 9.66699V11.0003C7.33329 11.3685 7.63176 11.667 7.99996 11.667C8.36816 11.667 8.66663 11.3685 8.66663 11.0003V9.66699Z"
			fill="currentColor"
		/>
	</svg>
);
const LIMITED_TIME_ICON = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.19653 0.873256C7.04207 0.807223 6.86473 0.823176 6.72453 0.915716C6.58436 1.00826 6.5 1.16502 6.5 1.33301C6.5 2.73438 5.60397 3.77835 4.62037 4.92428C3.61483 6.09742 2.5 7.46988 2.5 9.66634C2.5 12.7039 4.96243 15.1663 8 15.1663C11.0375 15.1663 13.5 12.7039 13.5 9.66634C13.5 8.94628 13.4915 7.48034 12.0571 5.68733C11.9265 5.52402 11.7079 5.45928 11.5094 5.52505C11.311 5.59079 11.1744 5.77318 11.167 5.98206C11.167 5.98206 11.1529 6.14241 11.1415 6.21656C11.1182 6.36822 11.0767 6.55541 11.0064 6.72661C10.9343 6.90221 10.8485 7.02074 10.7606 7.08488C10.6917 7.13521 10.5871 7.17941 10.3865 7.13748C10.2149 7.10161 10.1283 7.03841 10.0728 6.97314C10.0097 6.89901 9.95247 6.78088 9.9108 6.58583C9.86887 6.38968 9.84973 6.15117 9.8384 5.86036C9.83427 5.75526 9.83113 5.63684 9.82773 5.5122C9.8226 5.31863 9.817 5.11006 9.80693 4.91322C9.7724 4.2385 9.67933 3.4594 9.30553 2.72981C8.9236 1.98424 8.27093 1.33255 7.19653 0.873256ZM7.83147 7.29014C7.81807 7.13374 7.73187 6.99268 7.5988 6.90934C7.4658 6.82594 7.30127 6.80994 7.15467 6.86601C6.51398 7.11121 6.02315 7.70054 5.70355 8.26454C5.38191 8.83214 5.16667 9.49268 5.16667 9.99968C5.16667 10.9344 5.46284 11.7279 5.98183 12.2929C6.50173 12.859 7.22013 13.1671 8 13.1671C9.67447 13.1671 10.8333 11.4759 10.8333 9.66714C10.8333 9.50314 10.7529 9.34954 10.6181 9.25614C10.4833 9.16274 10.3113 9.14134 10.1578 9.19894C9.69253 9.37341 9.3442 9.38861 9.08567 9.33281C8.8302 9.27768 8.6216 9.14461 8.4468 8.95021C8.08027 8.54261 7.88253 7.88368 7.83147 7.29014Z"
			fill="currentColor"
		/>
	</svg>
);
const LAST_DAY_ICON = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.19653 0.873256C7.04207 0.807223 6.86473 0.823176 6.72453 0.915716C6.58436 1.00826 6.5 1.16502 6.5 1.33301C6.5 2.73438 5.60397 3.77835 4.62037 4.92428C3.61483 6.09742 2.5 7.46988 2.5 9.66634C2.5 12.7039 4.96243 15.1663 8 15.1663C11.0375 15.1663 13.5 12.7039 13.5 9.66634C13.5 8.94628 13.4915 7.48034 12.0571 5.68733C11.9265 5.52402 11.7079 5.45928 11.5094 5.52505C11.311 5.59079 11.1744 5.77318 11.167 5.98206C11.167 5.98206 11.1529 6.14241 11.1415 6.21656C11.1182 6.36822 11.0767 6.55541 11.0064 6.72661C10.9343 6.90221 10.8485 7.02074 10.7606 7.08488C10.6917 7.13521 10.5871 7.17941 10.3865 7.13748C10.2149 7.10161 10.1283 7.03841 10.0728 6.97314C10.0097 6.89901 9.95247 6.78088 9.9108 6.58583C9.86887 6.38968 9.84973 6.15117 9.8384 5.86036C9.83427 5.75526 9.83113 5.63684 9.82773 5.5122C9.8226 5.31863 9.817 5.11006 9.80693 4.91322C9.7724 4.2385 9.67933 3.4594 9.30553 2.72981C8.9236 1.98424 8.27093 1.33255 7.19653 0.873256ZM7.83147 7.29014C7.81807 7.13374 7.73187 6.99268 7.5988 6.90934C7.4658 6.82594 7.30127 6.80994 7.15467 6.86601C6.51398 7.11121 6.02315 7.70054 5.70355 8.26454C5.38191 8.83214 5.16667 9.49268 5.16667 9.99968C5.16667 10.9344 5.46284 11.7279 5.98183 12.2929C6.50173 12.859 7.22013 13.1671 8 13.1671C9.67447 13.1671 10.8333 11.4759 10.8333 9.66714C10.8333 9.50314 10.7529 9.34954 10.6181 9.25614C10.4833 9.16274 10.3113 9.14134 10.1578 9.19894C9.69253 9.37341 9.3442 9.38861 9.08567 9.33281C8.8302 9.27768 8.6216 9.14461 8.4468 8.95021C8.08027 8.54261 7.88253 7.88368 7.83147 7.29014Z"
			fill="currentColor"
		/>
	</svg>
);
const COUP_DE_COEUR_ICON = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
		<path
			d="M7.74291 14.0954C7.90111 14.1902 8.09897 14.1902 8.25717 14.0954C8.44411 13.9755 9.00917 13.6127 9.32751 13.3909C9.96331 12.9479 10.8137 12.3151 11.666 11.5563C12.5162 10.7994 13.3819 9.90547 14.0384 8.93981C14.6918 7.97867 15.1667 6.90401 15.1667 5.7959C15.1666 3.63435 13.5656 1.83301 11.3334 1.83301C10.2722 1.83301 9.24417 2.17479 8.00004 3.30957C6.75591 2.17479 5.72793 1.83301 4.66671 1.83301C2.43441 1.83301 0.833407 3.63435 0.833374 5.7959C0.833374 6.90401 1.30821 7.97867 1.96163 8.93981C2.61821 9.90547 3.48382 10.7994 4.33403 11.5563C5.18635 12.3151 6.03675 12.9479 6.67257 13.3909C6.99091 13.6127 7.55597 13.9755 7.74291 14.0954Z"
			fill="currentColor"
		/>
	</svg>
);
const DISCOUNT_ICON = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.5989 1.31543H8.46555C7.99888 1.31543 7.53222 1.51543 7.19888 1.84876L1.86555 7.1821C1.13222 7.91543 1.13222 9.04876 1.86555 9.7821L6.66555 14.5821C7.39888 15.3154 8.53222 15.3154 9.26555 14.5821L14.5989 9.24876C14.9322 8.91543 15.1322 8.44876 15.1322 7.9821V1.84876C15.1322 1.5821 14.9322 1.31543 14.5989 1.31543ZM11.9322 5.7821C11.1989 5.7821 10.5989 5.1821 10.5989 4.44876C10.5989 3.71543 11.1989 3.11543 11.9322 3.11543C12.6656 3.11543 13.2656 3.71543 13.2656 4.44876C13.2656 5.1821 12.6656 5.7821 11.9322 5.7821Z"
			fill="currentColor"
		/>
	</svg>
);
const BAGGAGE_INCLUDED_ICON = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
		<path
			d="M11.5714 3.1H10.1429V1.7C10.1429 1.315 9.82143 1 9.42857 1H6.57143C6.17857 1 5.85714 1.315 5.85714 1.7V3.1H4.42857C3.64286 3.1 3 3.73 3 4.5V12.9C3 13.67 3.64286 14.3 4.42857 14.3C4.42857 14.685 4.75 15 5.14286 15C5.53571 15 5.85714 14.685 5.85714 14.3H10.1429C10.1429 14.685 10.4643 15 10.8571 15C11.25 15 11.5714 14.685 11.5714 14.3C12.3571 14.3 13 13.67 13 12.9V4.5C13 3.73 12.3571 3.1 11.5714 3.1ZM5.67857 12.2C5.38571 12.2 5.14286 11.962 5.14286 11.675V6.425C5.14286 6.138 5.38571 5.9 5.67857 5.9C5.97143 5.9 6.21429 6.138 6.21429 6.425V11.675C6.21429 11.962 5.97143 12.2 5.67857 12.2ZM8 12.2C7.70714 12.2 7.46429 11.962 7.46429 11.675V6.425C7.46429 6.138 7.70714 5.9 8 5.9C8.29286 5.9 8.53571 6.138 8.53571 6.425V11.675C8.53571 11.962 8.29286 12.2 8 12.2ZM9.07143 3.1H6.92857V2.05H9.07143V3.1ZM10.3214 12.2C10.0286 12.2 9.78571 11.962 9.78571 11.675V6.425C9.78571 6.138 10.0286 5.9 10.3214 5.9C10.6143 5.9 10.8571 6.138 10.8571 6.425V11.675C10.8571 11.962 10.6143 12.2 10.3214 12.2Z"
			fill="currentColor"
		/>
	</svg>
);

export const getSmartDPMapMarkerIcon = tag =>
	({
		[PRODUCT_TAG_CODES.GC_DISCONNECTED]: GC_DISCONNECTED_ICON,
		[PRODUCT_TAG_CODES.LIMITED_TIME]: LIMITED_TIME_ICON,
		[PRODUCT_TAG_CODES.LAST_DAY]: LAST_DAY_ICON,
		[PRODUCT_TAG_CODES.COUP_DE_COEUR]: COUP_DE_COEUR_ICON,
		[PRODUCT_TAG_CODES.DISCOUNT]: DISCOUNT_ICON,
		[PRODUCT_TAG_CODES.BAGGAGE_INCLUDED]: BAGGAGE_INCLUDED_ICON,
	})[tag] || null;

export const getSmartDPMapInfo = (accommodation, { brand, isUserConnected, strategy }) => {
	const flightOptions = accommodation.flightDetails?.flightOptions;
	const isBaggageFree = Boolean(
		findLast(
			flightOptions?.flightBagageOptions,
			option =>
				flightOptions?.flightBagageOption?.canBeBooked &&
				flightOptions?.flightBagageOption?.included === false &&
				option?.pricePerBooking === 0
		)
	);
	const isFavorite = shouldShowFavoriteBadge(accommodation);
	const unbeatableOfferTag = getUnbeatableOffer(accommodation);
	const discountBadgeVisibility = accommodation?.discountBadgeVisibility;
	const shouldDisplayMemberOnlyTag =
		isBrandWithAccount({ brand, strategy }) &&
		!isUserConnected &&
		[PRODUCT_TAG_CODES.LIMITED_TIME, PRODUCT_TAG_CODES.LAST_DAY].includes(unbeatableOfferTag);

	// Map marker shows a single badge tag; order is priority (first match wins):
	// GC_DISCONNECTED → LIMITED_TIME → LAST_DAY → CDC → DISCOUNT → BAGGAGE_INCLUDED
	const tag = [
		[shouldDisplayMemberOnlyTag, PRODUCT_TAG_CODES.GC_DISCONNECTED],
		[unbeatableOfferTag === PRODUCT_TAG_CODES.LIMITED_TIME, PRODUCT_TAG_CODES.LIMITED_TIME],
		[unbeatableOfferTag === PRODUCT_TAG_CODES.LAST_DAY, PRODUCT_TAG_CODES.LAST_DAY],
		[isFavorite, PRODUCT_TAG_CODES.COUP_DE_COEUR],
		[discountBadgeVisibility, PRODUCT_TAG_CODES.DISCOUNT],
		[isBaggageFree, PRODUCT_TAG_CODES.BAGGAGE_INCLUDED],
	].find(([matches]) => matches)?.[1];

	const TagIcon = getSmartDPMapMarkerIcon(tag);
	const tagIconElement = TagIcon ? <TagIcon /> : null;

	return {
		tag,
		isBaggageFree,
		isFavorite,
		unbeatableOfferTag,
		discountBadgeVisibility,
		icon: tagIconElement,
	};
};

export const useSmartDPMapInfo = accommodation => {
	const { brand, isUserConnected, strategy } = useContext(AppGlobalsContext);
	return getSmartDPMapInfo(accommodation, { brand, isUserConnected, strategy });
};
